import React from 'react';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="section-container" data-id="element-138">
      <div className="text-container" data-id="element-139">
        <div className="flex items-center justify-center mb-6" data-id="element-140">
          <AlertCircle className="w-10 h-10 text-gold mb-4" data-id="element-141" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-142">
          Después de los 40, las reglas del juego cambian.
        </h2>

        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-soft border border-sage-light/30" data-id="element-143">
          <p className="text-lg md:text-xl leading-relaxed text-charcoal mb-6" data-id="element-144">
            El estrógeno cae, el estrés sube y lo que antes te funcionaba para
            bajar de peso, ahora parece inflamarte más.
          </p>
          <p className="text-lg md:text-xl leading-relaxed text-charcoal mb-6" data-id="element-145">
            Vives con esa sensación constante de que tu cuerpo ya no te
            responde. El cansancio es crónico, la digestión es lenta y cada
            mañana es una batalla frente al espejo intentando que la ropa te
            quede como hace un par de años.
          </p>
          <div className="bg-cream p-6 rounded-xl border-l-4 border-sage-dark mt-8" data-id="element-146">
            <p className="text-lg md:text-xl font-medium text-charcoal-dark italic" data-id="element-147">
              "Lo peor es que te dicen que 'es la edad' y que te acostumbres."
            </p>
          </div>
        </div>
      </div>
    </section>;
}